import moment from "moment";
import {
    SET_APPROVAL_HISTORY_REPORT,
    SET_APPROVAL_HISTORY_REPORT_EXCEL_DATA,
    SET_APPROVAL_MANAGMENT_TAB,
    SET_APPROVAL_HISTORY_REPORT_FILTERS,
    SET_APPROVAL_HISTORY_REPORT_DETAILS,
    SET_APPROVAL_HISTORY_DETAIL_EXCEL_DATA
} from "./ApprovalHistoryReportType"

const initialState = {
    approvalHistoryReport: null,
    approvalHistoryReportExcelData: null,
}

const reducer = (state = initialState, action: any) => {
    switch (action.type) {
        case SET_APPROVAL_HISTORY_REPORT:
            return {
                ...state,
                approvalHistoryReport: action.response
            };
        case SET_APPROVAL_HISTORY_REPORT_EXCEL_DATA:
            return {
                ...state,
                approvalHistoryReportExcelData: action.response
            };
        case SET_APPROVAL_MANAGMENT_TAB:
            return {
                ...state,
                approvalManagementTab: action.payload
            };
        case SET_APPROVAL_HISTORY_REPORT_FILTERS:
            return {
                ...state,
                approvalHistoryReportFilters: action.payload
            };
        case SET_APPROVAL_HISTORY_REPORT_DETAILS:
            return {
                ...state,
                approvalHistoryReportDetails: action.response,
            };
        case SET_APPROVAL_HISTORY_DETAIL_EXCEL_DATA:
            return {
                ...state,
                approvalHistoryDetailExcel: action.response,
            };
        default:
            return state;
    }
};

export default reducer;